/**
 * PosicaoMotorista
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Motorista} from '@/model/resource/Motorista'
import {PosicaoMotoristaCollection} from '@/model/collection/PosicaoMotoristaCollection'

/* TODO: review generated class */
export class PosicaoMotorista extends Resource {
  idPosicaoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  latitude: number | null = null
  longitude: number | null = null
  data: string | null = null

  distanciaParaDestinoEmMetros: number | null = null
  duracaoParaDestinoEmSegundos: number | null = null

  get $id() {
    return this.idPosicaoPk
  }
  set $id(val) {
    this.idPosicaoPk = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of PosicaoMotorista
   */
  async getPosicaoMotorista(id: number) {
    return await Request.get(`/admin/posicao-motorista/${id}`)
      .name('getPosicaoMotorista')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of PosicaoMotorista
   */
  static async listPosicaoMotorista(params: any) {
    return await Request.get(`/admin/posicao-motorista`, {params})
      .name('listPosicaoMotorista')
      .as(PosicaoMotoristaCollection)
      .getData()
  }

  /**
   * Persists a new instance of PosicaoMotorista. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistPosicaoMotorista() {
    return await Request.post(`/admin/posicao-motorista`, this)
      .name('persistPosicaoMotorista')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of PosicaoMotorista to use it in a CSV file
   */
  static async listCsvPosicaoMotorista(params: any) {
    return await Request.get(`/admin/posicao-motorista/csv`, {params})
      .name('listCsvPosicaoMotorista')
      .as(PosicaoMotoristaCollection)
      .getData()
  }
}
